export default __webpack_public_path__ + "images/sucess-icon.2fa7d925.svg";